import { atom } from "recoil";

export type ModalType = {
  visibleConfirm: boolean;
  handleConfirm?: any;
  title: string;
  successText?: string;
  cancelText?: string;
  shouldReload?: boolean;
};

export const confirmModalState = atom<ModalType>({
  key: "confirmModalState",
  default: {
    visibleConfirm: false,
    shouldReload: false,
    handleConfirm: null,
    title: "",
    successText: "",
    cancelText: "",
  },
});
